module.exports = __webpack_public_path__ + "img/taur-live2.58ac3184.png";